<template>

    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-exchange-fill"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                                <p class="cf-modal-head__sub">Normalisation</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <div class="cf-dialog-body">



                    <div class="box  overflow-hidden">
                        <div class="box-header justify-between " style="display: block">



                            <div class="grid grid-cols-12  gap-x-6">


                                <div class=" xl:col-span-8  col-span-12 mt-4 mb-4">
                                    <input v-model="searchword" class="form-control form-control-lg w-full custom-placeholder" type="text"
                                           placeholder="Rechercher"
                                           aria-label=".form-control-lg example">
                                </div>

                                <div class="xl:col-span-3  col-span-12 mt-4 mb-4"></div>


                                <div class="xl:col-span-1  col-span-12 mt-4 mb-4">
                                    <button  @click="btnajouter" class="ti-btn ti-btn-primary-full !py-1 !px-2 !text-[0.75rem] w-full">
                                        <i class="ri-add-line  align-middle"></i>Ajouter
                                    </button>
                                </div>



                                <div class=" xl:col-span-6  col-span-12 mt-4 mb-4">

                                    <select v-model="DefaultperPage" style=" display: inline-block; margin: 0 5px; padding: 2px 25px;
                                            border: 1px solid #aaa; border-radius: 3px;" class="tabulator-page-size" aria-label="Page Size" title="Affichage">
                                        <option value="4">4</option>
                                        <option value="10">10</option>
                                        <option value="30">30</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>

                                    </select>
                                </div>


                            </div>


                            <div class="w-full flex grid-cols-2">

                                <div class="box-title mb-2 sm:mb-0"></div>

                                <div class="inline-flex rounded-md shadow-sm" role="group" aria-label="Basic example">
                                    <button type="button" @click="indexbutton='1d';load()" :class="indexbutton==='1d'?'ti-btn-primary-full text-white':'ti-btn-primary'" class="ti-btn-group !border-0 !text-xs !py-2 !px-3  ">1D</button>
                                    <button type="button" @click="indexbutton='3d';load()" :class="indexbutton==='3d'?'ti-btn-primary-full text-white':'ti-btn-primary'" class="ti-btn-group !border-0 !text-xs !py-2 !px-3 ">3D</button>
                                    <button type="button" @click="indexbutton='7d';load()" :class="indexbutton==='7d'?'ti-btn-primary-full text-white':'ti-btn-primary'" class="ti-btn-group !border-0 !text-xs !py-2 !px-3 ">1W</button>
                                    <button type="button" @click="indexbutton='1M';load()" :class="indexbutton==='1M'?'ti-btn-primary-full text-white':'ti-btn-primary'" class="ti-btn-group !border-0 !text-xs !py-2 !px-3 ">1M</button>
                                    <button type="button" @click="indexbutton='3M';load()" :class="indexbutton==='3M'?'ti-btn-primary-full text-white':'ti-btn-primary'" class="ti-btn-group !border-0 !text-xs !py-2 !px-3 ">3M</button>
                                    <button type="button" @click="indexbutton='6M';load()" :class="indexbutton==='6M'?'ti-btn-primary-full text-white':'ti-btn-primary'" class="ti-btn-group !border-0 !text-xs !py-2 !px-3 ">6M</button>
                                    <button type="button" @click="indexbutton='12M';load()" :class="indexbutton==='12M'?'ti-btn-primary-full text-white':'ti-btn-primary'" class="ti-btn-group !border-0 !text-xs !py-2 !px-3  !rounded-s-none">12M</button>
                               </div>
                            </div>






                        </div>


                        <div class="box-body !p-0 mybodyheight300px">
                            <div class="table-responsive">



                                <div class="flex flex-col h-screen">
                                    <div class="flex-grow overflow-auto">




                                        <table class="relative w-full border table mytable table-hover whitespace-nowrap min-w-full">
                                            <thead>
                                            <tr>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">N°</th>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">N° DOCUMENT</th>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">CLIENT</th>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">ETAT</th>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">CREER LE</th>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">CREER PAR</th>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">Action</th>

                                            </tr>
                                            </thead>
                                            <tbody>

                                            <template v-if="filterdatatable.length">

                                                <tr  class="border-t hover:bg-gray-200 dark:hover:bg-light" v-for="(datavalue,index) in filterdatatable" :key="index">

                                                    <td data-label="N°  : ">{{index+1}}</td>
                                                    <td  data-label="N° DOCUMENT  : "   >{{ datavalue.numdoc }}</td>
                                                    <td  data-label="CLIENT  : "   >{{ datavalue.client }}</td>
                                                    <td  data-label="ETAT  : "   >

                                                        <template v-if="parseFloat(datavalue.normalise)===1">Normaliser</template>
                                                        <template v-else>Non normaliser</template>

                                                    </td>
                                                    <td  data-label="CREER LE  : "   >{{ datavalue.creerler }}</td>
                                                    <td  data-label="CREER PAR  : "   >{{ datavalue.saisiepar }}</td>

                                                     <td  data-label="Action  : "   >


                                                        <div class="ti-btn-group">
                                                            <div class="cf-actions">
                                                            <button @click="btnimpression(datavalue)" class="cf-iconbtn cf-iconbtn--success" title="Imprimer"><i class="ri-printer-fill"></i></button>
                                                            <button v-if="parseFloat(datavalue.normalise)===0" @click="btnsuppression(datavalue)" class="cf-iconbtn cf-iconbtn--danger" title="Supprimer"><i class="ri-delete-bin-line"></i></button>
                                                        </div>
                                                        </div>




                                                    </td>

                                                </tr>



                                            </template>


                                            <template v-else>
                                                <tr >
                                                    <td colspan="20"><div class="alert alert-danger text-center">Aucun enregistrement n'a été trouvé.</div></td>
                                                </tr>

                                            </template>



                                            </tbody>
                                        </table>


                                    </div>
                                </div>

                            </div>
                        </div>





                        <div class="flex flex-col box-footer border-t-0 ">
                            <div class="flex items-center flex-wrap overflow-auto">
                                <div class="mb-2 sm:mb-0">

                                </div>
                                <div class="ms-auto">


                                    <nav aria-label="Page navigation">
                                        <ul class="ti-pagination mb-0">
                                            <li class="page-item">
                                                <button :class="{ 'disabled': page <= 1 }" class="page-link px-3 py-[0.375rem]" @click="page--">Previous</button>
                                            </li>
                                            <li class="page-item">
                                                <button class="page-link px-3 py-[0.375rem]" :class="{ 'active': pageNumber === page }"
                                                        :key="key" v-for="(pageNumber, key) in displayedPages" @click="page = pageNumber">
                                                    {{ pageNumber }}
                                                </button>
                                            </li>
                                            <li class="page-item">
                                                <button :class="{ 'disabled': page >= pages.length }" class="page-link px-3 py-[0.375rem]" @click="page++">Next</button>
                                            </li>
                                        </ul>
                                    </nav>





                                </div>
                            </div>
                        </div>
                    </div>






                </div>



                <div class="cf-dialog-foot">


                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full" >
                        Fermer
                    </button>


                </div>
                </div>
            </Transition>
        </div>
    </Transition>

    <modalform ref="modalform"  @closed="load"></modalform>
    <modalformsuppression @closed="load"  ref="modalformsuppression"></modalformsuppression>
      <normalisationdelafacture @closed="load" ref="normalisationdelafacture"  ></normalisationdelafacture>


    <vente_facture_etat0 ref="vente_facture_etat0"  ></vente_facture_etat0>
    <vente_facture_etat1 ref="vente_facture_etat1"  ></vente_facture_etat1>
    <vente_facture_etat2 ref="vente_facture_etat2"  ></vente_facture_etat2>
    <vente_facture_etat3 ref="vente_facture_etat3"  ></vente_facture_etat3>
    <vente_facture_etat4 ref="vente_facture_etat4"  ></vente_facture_etat4>
    <vente_facture_etat5 ref="vente_facture_etat5"  ></vente_facture_etat5>





</template>

<script>

    const axios =require('axios');

    import normalisationdelafacture from "@/components/views/pages/gestioncommerciale/achatvente/normalisationdelafacture";
    import modalform from "@/components/views/pages/setting/utilitaires/noramlisationextra/form";
    import modalformsuppression from "@/components/views/pages/setting/utilitaires/noramlisationextra/formsuppression";



    import vente_facture_etat0 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_facture/0";
    import vente_facture_etat1 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_facture/1";
    import vente_facture_etat2 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_facture/2";
    import vente_facture_etat3 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_facture/3";
    import vente_facture_etat4 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_facture/4";
    import vente_facture_etat5 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_facture/5";

    import qrcodetoimage from 'qrcode';


    import { randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },

        },
        computed:{

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable;

                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;


                if (this.searchword!==''){
                    let t=this;



                    mvalue = mvalue.filter( function (post) {
                        return    post.numdoc.toString().toLowerCase().includes(t.searchword.toLowerCase())
                                 || post.nameclient.toString().toLowerCase().includes(t.searchword.toLowerCase())


                    })

                }



                return this.paginate(mvalue) ;
            },
        },
        components: {
            modalform,
            modalformsuppression,


            normalisationdelafacture,



            vente_facture_etat0,
            vente_facture_etat1,
            vente_facture_etat2,
            vente_facture_etat3,
            vente_facture_etat4,
            vente_facture_etat5,



        },

        data() {
            return {
                isdisplay:false,
                titlemodal:"",
                datatable:[],
                otherdata:[],
                listedupersonnel:[],
                datainputlibelleforms:{},
                customlibelleforms:{},
                datatiers:[],
                typedoc:"",
                typededocument:"",
                messageerror:"",
                messagesucces:"",
                indexbutton:'1d',

                accesnewbtn:false,
                accesupdatebtn:false,
                accesdeletebtn:false,


                searchword:"",
                searchtrierletableau:"",

                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 4,
                Defaultpage: 1,
                DefaultperPage: 4,
                pages: [],
            };
        },
        methods: {

            btnajouter(){


                let mname

                let  Item= {
                    pid:'',
                    mag:null,
                    datedoc:this.$store.state.appserverdate,
                    docobservation:'',
                    docnum:'',
                    docnumother:'',
                    docpid:0,
                    doctyp:this.typedoc,
                    infodoc:{
                        infolibre:'',
                        infolibre1:'',
                        infolibre2:'',
                        infolibre3:'',
                    },
                    jsonotherdonne:{
                        datedelivraison:'',
                        dateechancefacture:'',
                        tpdoc:"",
                        tredocument:"",
                        magvers:null,
                        mtypprixdevente:'prixvente',
                        collaborateur:null,
                        cltfrs:null,
                        moderglt:null,
                        cdtreglement:null,
                        appliquetva:1,
                        aib:0,
                        adresseexpedition:{
                            infolibre:'',
                            infolibre1:'',
                            infolibre2:'',
                            infolibre3:'',
                        },
                        infodoc:{
                            infolibre:'',
                            infolibre1:'',
                            infolibre2:'',
                            infolibre3:'',
                            infolibre4:'',
                            infolibre5:'',
                            infolibre6:'',
                            infolibre7:'',
                            infolibre8:'',
                            infolibre9:'',
                            infolibre10:'',
                            infolibre11:'',
                        },
                        piedsinfodoc:{
                            infolibre:'',
                            infolibre1:'',
                            infolibre2:'',
                            infolibre3:'',
                        },


                    },
                    mtnt:{

                        docmtntaib: "0",
                        docmtntremise: "0",
                        docmtnttotalht: "0",
                        docmtnttotalttc: "0",
                        doctva: "0",
                        doccalmtnttotalht: "0",
                        libaib: "AIB"


                    },
                    params:{
                        param1:null,
                        param2:null,
                        param3:null,
                        param4:null,
                    },
                    jsondoc:{},
                    jsondocne:{
                        usetva:1,
                        aib:0,
                        datedoc:this.$store.state.appserverdate,
                        client:'',
                        ifu:'',
                        items:[]

                    }
                }

                mname="Enregistrer la normalisation d'une facture extra"


                this.$refs.modalform.show(mname,"add",this.typedoc,Item);

            },


            async load(){

                this.isdisplay=true;
                this.perPage=this.DefaultperPage;
                        this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/utilitaire/normalisationextra/all/FNE/'+this.indexbutton+'/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){


                            t.datatable=[];
                            t.datatable=res.data.m;
                             t.isdisplay=true;

                        }
                        else{
                            t.datatable=[];

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },



            async btnimpression(value){


                for(let $line of value.items){
                    $line.autredesignation=""
                    let $article=$line.article
                    $line.article={
                        libelle:$line.article,
                        taxedimposition:$line.taxedimposition,

                    }

                }


                let   tabvalue={}


                 /*   <tr v-for="(item,index) in tabvalue.items" :key="index">
                    <td style="text-align: center;"> {{index+1}}</td>
                <td v-if="item.autredesignation!==''">{{item.article.libelle+' ('+item.autredesignation+')'+' ('+item.article.taxedimposition+')'}} </td>
                <td v-else>{{item.article.libelle+' ('+item.article.taxedimposition+')'}} </td>
                <td style="text-align: center;">{{formatquantite(item.qtite)}}</td>
                <td style="text-align: center;">{{formatMonney(item.pu)}}</td>
                <td style="text-align: center;">{{formatMonney(item.mtnt)}}</td>

                </tr>*/


                tabvalue={
                    jsoncltfrs:{
                        typcltfrs:'',
                        raisonsociale:value.client,
                        ifu:value.ifu,
                        telephone:"",
                        adresse:"",
                        codeclient:""
                    },
                    jsoncol:{
                        name:'',
                    },
                    titresignataire:"",
                    nomdusignataire:"",
                    texteavance:"",
                    textesole:"",
                    infolibre2:"",

                    infolibre:"",
                    infolibre1:"",
                    infolibre22:"",
                    infolibre3:"",
                    infolibre4:"",
                    infolibre5:"",
                    infolibre6:"",
                    infolibre7:"",
                    infolibre8:"",
                    infolibre9:"",
                    infolibre10:"",
                    infolibre11:"",

                    libelledefacture:value.doctyp,
                    cltfrs:value.client,
                    numdoc:value.numdoc,
                    operateur:value.saisiepar,
                    othernumdoc:"",

                    observations:"",
                    date:value.datedoc,
                    items:value.items,
                    montantht:parseFloat(value.mtnt.docmtnttotalht),
                    montanttva:parseFloat(value.mtnt.doctva),
                    montantremise:parseFloat(value.mtnt.docmtntremise),
                    montantnetapayer:parseFloat(value.mtnt.docmtnttotalttc),
                    montantaib:parseFloat(value.mtnt.docmtntaib),
                    libaib:value.mtnt.libaib,

                    formattext:'',

                    mecefsignature:'',
                    mecefnim:'',
                    mecefcompteur:'',
                    mecefheure:'',
                    mecefqrr:'',
                    normalise:0,


                    /************************** signature ****************/

                    signature:{
                        titredoc:"",
                        titresignataire:"",
                        namesignataire:"",
                        imgsignature:"",
                        datasignataires:[],
                        imgsignataires:[]
                    }




                }



                    tabvalue.signature.titredoc=this.$store.state.paramsapp.signataire.ventefacture.titredoc
                    tabvalue.signature.datasignataires=this.$store.state.paramsapp.signataire.ventefacture.signataires



                    tabvalue.jsoncltfrs.typcltfrs="CLIENT";
                    if (value.infodoc.normalise===1){

                        let urlimagegenerer="";

                        // Générer un QR code sous forme d'URL de données
                         qrcodetoimage.toDataURL(value.infodoc.doccollecte.data.qrCode, { width: 125, margin: 2 }, (err, url) => {
                            if (err) {
                                console.error(err);
                            } else {



                                urlimagegenerer=  url;
                            }
                        });

                        tabvalue.mecefsignature=value.infodoc.doccollecte.data.codeMECeFDGI
                        tabvalue.mecefnim=value.infodoc.doccollecte.data.nim
                        tabvalue.mecefcompteur=value.infodoc.doccollecte.data.counters
                        tabvalue.mecefheure=value.infodoc.doccollecte.data.dateTime
                        //tabvalue.mecefqrr=value.infodoc.doccollecte.data.qrCode
                        tabvalue.mecefqrr=urlimagegenerer ,
                            tabvalue.normalise=value.infodoc.normalise
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventefacture.document)===0){

                        console.log("tabvalue ******** ",tabvalue)

                        this.$refs.vente_facture_etat0.show(tabvalue);

                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventefacture.document)===1){


                        this.$refs.vente_facture_etat1.show(tabvalue);

                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventefacture.document)===2){

                        this.$refs.vente_facture_etat2.show(tabvalue);

                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventefacture.document)===3){

                        this.$refs.vente_facture_etat3.show(tabvalue);

                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventefacture.document)===4){

                        this.$refs.vente_facture_etat4.show(tabvalue);

                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventefacture.document)===5){

                        this.$refs.vente_facture_etat5.show(tabvalue);

                    }




            },


            btnmodifier(value){

                let titlemodal="Modifier le document "+value.numdoc

                let Item=value

                this.$refs.modalform.showupdate(titlemodal,"update",this.typedoc,Item,this.otherdata,this.datainputlibelleforms,this.typededocument,this.customlibelleforms);


            },


            btnsuppression(value){

                if (value.useline===1 || value.useline==='1'){

                    toastr['error']( "Impossible de supprimer cette ligne. Veuillez contacter votre administrateur. ","<b></b>");
                    return
                }


                let titlemodal="VOULLEZ-VOUS VRAIMENT SUPPRIMER LE DOCUMENT "+value.numdoc+" ?";

                this.$refs.modalformsuppression.show(titlemodal,value,this.typedoc,this.typededocument);

            },

            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },

            selected(datavalue){


                // Suppose que vous avez un objet représentant l'élément sélectionné
                const elementSelectionne = { typ: this.typedoc, value: datavalue};

                // Émettre un événement personnalisé avec l'élément sélectionné
                this.$emit('elementSelectionne', elementSelectionne);

                // Fermer le modal ou effectuer d'autres actions nécessaires
                this.isdisplay=false;
            },


            show(){


                this.searchword="";
                this.messagesucces="";
                this.messageerror="";
                this.titlemodal="Normalisation Extrat des factures"


                this.indexbutton='1d';
                this.datatable=[];

                this.typedoc="NE"
                this.typededocument="NE"


                this.load()



            },



            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1200px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }
@media (max-width:768px) { .cf-dialog--xxl { max-width:100%; } }

.cf-th{background:var(--cf-surface-alt)!important;color:var(--cf-ink)!important;font-weight:600;font-size:0.75rem;}
.cf-actions{display:inline-flex;align-items:center;gap:4px;}
.cf-iconbtn{height:2rem;width:2rem;display:inline-flex;align-items:center;justify-content:center;border:none;border-radius:var(--cf-radius-sm);cursor:pointer;font-size:1rem;transition:all .15s;background:var(--cf-surface-alt);color:var(--cf-muted);}
.cf-iconbtn--primary:hover{background:rgb(var(--primary)/0.12);color:rgb(var(--primary));}
.cf-iconbtn--danger:hover{background:rgb(var(--danger)/0.12);color:rgb(var(--danger));}
</style>